// extracted by mini-css-extract-plugin
export var black = "_redotech-arbiter-lib-featured-icon-redo-featured-icon-colors-black";
export var brand = "_redotech-arbiter-lib-featured-icon-redo-featured-icon-colors-brand";
export var ddefault = "_redotech-arbiter-lib-featured-icon-redo-featured-icon-colors-ddefault";
export var error = "_redotech-arbiter-lib-featured-icon-redo-featured-icon-colors-error";
export var gray = "_redotech-arbiter-lib-featured-icon-redo-featured-icon-colors-gray";
export var highContrast = "_redotech-arbiter-lib-featured-icon-redo-featured-icon-colors-high-contrast";
export var outline = "_redotech-arbiter-lib-featured-icon-redo-featured-icon-colors-outline";
export var success = "_redotech-arbiter-lib-featured-icon-redo-featured-icon-colors-success";
export var warning = "_redotech-arbiter-lib-featured-icon-redo-featured-icon-colors-warning";